import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  stockoutCreationSO: null,
  loading: false,
  error: null,
};

const stockoutCreationSOSlice = createSlice({
  name: "stockoutCreationSO",
  initialState,
  reducers: {
    fetchStockoutCreationSOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchStockoutCreationSOSuccess: (state, action) => {
      state.loading = false;
      state.stockoutCreationSO = action.payload;
      state.error = null;
    },

    fetchStockoutCreationSOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchStockoutCreationSOStart,
  fetchStockoutCreationSOSuccess,
  fetchStockoutCreationSOFailure,
} = stockoutCreationSOSlice.actions;

export default stockoutCreationSOSlice.reducer;